import styled from "styled-components";

export const CommentModalStyled = styled.div`
	padding: 2rem;

	#comments {
		margin-bottom: 1rem;
		padding: 10px 0;

		width: 100%;
		min-height: 200px;
		max-height: 250px;

		display: flex;
		flex-direction: column;
		row-gap: 1.5rem;

		overflow-y: scroll;

		.comment.small {
			align-items: center;
		}

		#sentinela {
			height: 5rem;
			width: 100%;
			background-color: teal;
		}
	}

	.model-footer {
		display: flex;
		justify-content: space-between;
		align-items: center;
		column-gap: 1rem;

		.user-img {
			width: 40px;
			height: 40px;

			img {
				width: 100%;
				height: 100%;
				border-radius: 50%;
			}
		}
		.message {
			flex: 1;
			input {
				width: 100%;
				padding: 1.3rem 0rem 1.3rem 1.5rem;

				color: var(--color-white-fixed);
				background-color: var(--color-brand-5-transparent);
				border: none;
				border-radius: 20px;

				outline: none;
				transition: all 0.3s ease;

				&:hover {
					background-color: var(--color-brand-2);
				}

				&:focus {
					background-color: var(--color-brand-5);
				}
			}
		}
	}
`;
